import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SSO_SIGN_OUT_MSG } from '../constants/storage-constants';

export const signOutMessageResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): Observable<string> => {
  const message: string = localStorage.getItem(SSO_SIGN_OUT_MSG);

  return of(message ? message : 'ALERT_PAGE.YOU_HAVE_BEEN_SIGNED_OUT');
};
